import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

// initial state
const state = {
  sortingEditKey: '',
  search: {
    page: 1,
    limit: 20,
    sort: 'id',
    order: 'desc',
    keyword: '',
    priceStatus: false,
    priceType: 'between',
    price1: '1',
    price2: '1000',
    validatePrice1: false,
    validatePrice2: false,
    stockStatus: false,
    stockType: 'between',
    stock1: '1',
    stock2: '1000',
    categoryId: 0,
    productStatus: false,
    productStatusType: 'show',
    advanceSearch: false,
    searchInputClear: false,
    productLabel: false,
    productLabelType: '1',
    isSearch: false,
    countSearchFilter: 0,
    isSearchLoading: false
  },
  result: {
    list: [],
    count: 0,
    page: 1,
    translations: {},
    pricingModels: {}
  },
  current: {},
  countAll: '',
  productTabSelected: 'productInCategory',
  currentView: 'ManageProducts'
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products/index.js